// LLM generated - Model Claude 4 Sonnet
import { useMantineTheme, Divider } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';
import { Text } from '~/domains/design-system/Text';
import { OauthSSO } from '~/domains/auth/components/SSOButtons/SSOButtons';
import { PLATFORMS, BRANDS } from '~/domains/auth/consts';
import useSignInStyles from '../../SignInActions/SignInActions.styles';
import useStyles from '../LoginHeader.styles';
import { HeaderTitle } from './HeaderTitle';
import { HeaderSubtitle } from './HeaderSubtitle';
import { BrandBadges } from './BrandBadges';
import type { titleStyles } from '~/domains/design-system/Title';

type SSOHeaderProps = {
  title: string;
  brandText: string;
  platform?: PLATFORMS;
  titleVariant?: keyof typeof titleStyles;
  brand?: BRANDS;
  isLogoVisible?: boolean;
};

export function SSOHeader({
  title,
  brandText,
  platform,
  titleVariant,
  brand,
  isLogoVisible = true,
}: SSOHeaderProps) {
  const { classes } = useStyles();
  const { classes: signInClasses } = useSignInStyles();
  const { t } = useTranslation('auth');

  return (
    <div className={signInClasses.ssoButtonContainer}>
      {brand && brand !== BRANDS.SPLASH && isLogoVisible && (
        <BrandBadges brand={brand} className={classes.brandBadgesContainer} />
      )}
      <div className={classes.titleSubtitleContainer}>
        <HeaderTitle title={title} variant={titleVariant} className={classes.LoginHeaderTitle} />
        <HeaderSubtitle text={brandText} />
      </div>
      <OauthSSO>
        <OauthSSO.Facebook />
        <OauthSSO.Google />
        {platform === PLATFORMS.IOS && <OauthSSO.Apple />}
      </OauthSSO>
      <Divider
        color="gray2.0"
        size="xs"
        label={
          <Text variant="body-large" c="gray2.3">
            {t('common.or').toUpperCase()}
          </Text>
        }
        labelPosition="center"
        labelProps={{ color: 'gray2.3' }}
        className={signInClasses.divider}
      />
    </div>
  );
}
